export const pricingVersionLabel = (version: { versionId: string; displayName?: string }): string =>
  version.displayName && version.displayName !== version.versionId ? version.displayName : 'Unnamed pricing version';
